export default {
  computed: {
    hasDeleteUserPermissions() {
      return (
        this.isMerchantAdmin || this.$role.verify([this.$role.DELETE_USER])
      );
    },
    hasViewActivityLogPermission() {
      return this.verifyAuth([this.$role.VIEW_ACTIVITY_LOG]);
    },
    isMerchantAdmin() {
      return this.$role.verify([this.$role.MERCHANT_ADMIN]);
    },
    isAdmin() {
      return this.$role.verify([this.$role.ADMIN]);
    },
    authenticated() {
      return this.$role.verify([
        this.$role.CAN_VIEW_USERS,
        this.$role.MERCHANT_ADMIN,
        this.$role.ADMIN
      ]);
    }
  },
  methods: {
    verifyAuth(groups) {
      return this.isAdmin || this.isMerchantAdmin || this.$role.verify(groups);
    }
  }
};
